















import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class SuccessDialog extends BaseComponent {
  @Prop()
  public isOpen: any;

  @Prop()
  public date: string[];

  @Prop()
  public msgSaveResult: string;
  
  public onCloseClick() {
    this.$emit('close');
  }

  public onNewPrescriptionClick() {
    this.$emit('newPrescription');
  }
}
